import {arahubAPI} from "config/axios";
import {API_ANALYTICS_URL} from "config";

const ROUTE = 'feature';

const getGalleryReport = async (_data) =>{
    try{
        const res = await arahubAPI.get(`${API_ANALYTICS_URL}${ROUTE}/gallery_report`,{
            responseType: 'blob',
            params: _data
        });
        return res.data
    }catch(err){
        return Promise.reject(err.response);
    }
}


const extraService={
    getGalleryReport,
}
export default extraService;